var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoursesActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M23,11.886c0-0.859-0.369-1.633-0.96-2.168C22.631,9.18,23,8.407,23,7.546c0-0.999-0.457-2.105-1.27-2.413 L12,2.528L1,5.474l0,0l11,2.945l0,0l0,0l0,0l0,0l7.741-2.062c0.104-0.029,0.213-0.043,0.325-0.043c0.688,0,1.247,0.558,1.247,1.245 c0,0.588-0.407,1.081-0.956,1.212L12,11.013L1,8.067v1.746l11,2.946l0,0l0,0l0,0l0,0l7.741-2.063l0,0 c0.104-0.028,0.213-0.043,0.325-0.043c0.688,0,1.247,0.557,1.247,1.246c0,0.588-0.407,1.079-0.956,1.211L12,15.354L1,12.407v1.746 l11,2.945l0,0l0,0l0,0l0,0l7.741-2.029v0.003c0.104-0.03,0.213-0.045,0.325-0.045c0.688,0,1.247,0.559,1.247,1.246 c0,0.589-0.407,1.081-0.956,1.212L12,19.727L1,16.779v1.747l11,2.945l0,0l0,0l0,0l0,0l8.774-2.351l-0.004-0.015 c1.28-0.316,2.229-1.471,2.229-2.847c0-0.869-0.377-1.65-0.979-2.187C22.622,13.536,23,12.756,23,11.886z M12.006,6.711L8.903,5.879 l4.53-1.214l3.104,0.832L12.006,6.711z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursesActive);
export default __webpack_public_path__ + "static/media/courses_active.0d5f516d.svg";
export { ForwardRef as ReactComponent };